import { render, staticRenderFns } from "./FilterChips.vue?vue&type=template&id=7511af3b&scoped=true&"
import script from "./FilterChips.vue?vue&type=script&lang=js&"
export * from "./FilterChips.vue?vue&type=script&lang=js&"
import style0 from "./FilterChips.vue?vue&type=style&index=0&id=7511af3b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7511af3b",
  null
  
)

export default component.exports